import React, { useEffect, useState } from 'react';
import { ReactComponent as FileIcon } from 'assets/icons/file-icon.svg';
import AddGuestManually from './add-guest-manually';
import useEventDetailsContext from 'contexts/event-details.context';
import AddCsvFile, { FileDetailsType } from 'pages/get-started/add-your-team/add-csv-file';
import CurrencyInput from 'components/base/currency-input';
import * as XLSX from 'xlsx';
import { Input } from '@cokitchen/cokitchen-components';

const AddYourGuests = () => {
  const [files, setFiles] = useState<File | null>(null);
  const { formData, setFormData, active, setActive, setDisabled, isFormEmpty, setIsFormEmpty } =
    useEventDetailsContext();

  const handleChangeInput = (index: number, fieldName: string, value: string) => {
    const updatedTeamDetails = [...formData.guests];
    updatedTeamDetails[index] = {
      ...updatedTeamDetails[index],
      [fieldName]: value
    };
    setFormData({
      ...formData,
      guests: updatedTeamDetails
    });
    setIsFormEmpty(false);
  };

  useEffect(() => {
    const isDisabled =
      !formData.guests.length ||
      !formData.guests.every((data) => Object.values(data).every(Boolean));
    setDisabled(isDisabled);
  }, [active, formData]);

  const readFile = () => {
    if (files) {
      const reader = new FileReader();
      reader.readAsBinaryString(files);
      reader.onload = (e: ProgressEvent<FileReader>) => {
        const data = e.target?.result;
        const workbook = XLSX.read(data, { type: 'binary' });
        const fileDetails = workbook.SheetNames[0];
        const headers: string[] = (
          XLSX.utils.sheet_to_json(workbook.Sheets[fileDetails], { header: 1 })[0] as string[]
        ).map((header: string) => header.toLowerCase().replace(/ /g, '_'));
        let convertGuestsDetails = XLSX.utils.sheet_to_json(workbook.Sheets[fileDetails], {
          header: headers
        });
        convertGuestsDetails = convertGuestsDetails.slice(1);
        convertGuestsDetails = convertGuestsDetails.map((guest: any) => {
          delete guest['s/n'];
          return {
            ...guest,
            mobile_number: String(guest.mobile_number),
            budget: String(guest.budget)
          };
        });
        setFormData({ ...formData, guests: convertGuestsDetails as FileDetailsType[] });
      };
    }
  };
  useEffect(() => {
    readFile();
  }, [files]);

  return (
    <div className='flex flex-col max-w-[390px] w-full mx-auto'>
      <h2 className='text-2xl font-bold'>Add your guests</h2>
      <p className='text-[#6F7376] text-sm mt-2'>
        Ensure the phone number provided here is the same as that used to register/signin to the
        FoodCourt App
      </p>

      <div className='flex gap-4 my-6 flex-wrap sm:flex-nowrap'>
        <div>
          <AddCsvFile
            setFile={setFiles}
            active={active}
            setActive={setActive}
            fileDetails={formData.guests}
            setFileDetails={(newFileDetails: FileDetailsType[]) =>
              setFormData({
                ...formData,
                guests: newFileDetails
              })
            }
            isFormEmpty={isFormEmpty}
            formType='guests'
          />
        </div>
        <button
          disabled={!isFormEmpty}
          onClick={() => setActive('manual')}
          className={`border w-full sm:w-[185px] h-[139px] ${
            active === 'manual'
              ? 'border-[#E60A2B]'
              : formData.guests?.length > 0
              ? ' cursor-not-allowed border-[#EAEBEB]'
              : 'border-[#EAEBEB] hover:border-[#E60A2B]'
          } hover:border-[1.5px] p-4 rounded-md cursor-pointer space-y-3 flex flex-col`}>
          <div className='border border-[#EAEBEB] p-2 rounded-full  w-9 h-9 flex items-center'>
            <FileIcon />
          </div>
          <h2 className='text-sm font-semibold'>Add manually</h2>
          <p className='text-[#6F7376] text-xs font-normal text-start '>Add multiple guests</p>
        </button>
      </div>

      {active !== 'manual' &&
        formData.guests?.length !== 0 &&
        formData.guests.map((item, index) => (
          <div
            key={index}
            className='max-w-[396px] text-sm space-y-4 mt-4 border-b border-[#E9EAEC] w-full'>
            <div className='flex gap-2 flex-wrap w-full justify-between'>
              <div className='w-full sm:w-[47%]'>
                <Input
                  design='bordered'
                  type='text'
                  label='First Name'
                  name='first_name'
                  value={item.first_name}
                  onChange={(e) => handleChangeInput(index, 'first_name', e.target.value)}
                  placeholder='Enter a name'
                  className='mb-3'
                />
              </div>
              <div className='w-full sm:w-[47%]'>
                <Input
                  design='bordered'
                  type='text'
                  label='Last Name'
                  name='last_name'
                  value={item.last_name}
                  onChange={(e) => handleChangeInput(index, 'last_name', e.target.value)}
                  placeholder='Enter a name'
                  className='mb-3'
                />
              </div>
            </div>
            <div className='flex gap-2 flex-wrap w-full justify-between'>
              <div className='w-full sm:w-[47%]'>
                <Input
                  design='bordered'
                  type='text'
                  label='Email'
                  name='email'
                  value={item.email}
                  onChange={(e) => handleChangeInput(index, 'email', e.target.value)}
                  placeholder='Enter a name'
                  className='mb-3'
                />
              </div>
              <div className='w-full sm:w-[47%]'>
                <Input
                  design='bordered'
                  type='phone'
                  label='Phone Number'
                  name='mobile_number'
                  value={item.mobile_number}
                  onChange={(e) => handleChangeInput(index, 'mobile_number', e.target.value)}
                  placeholder='Phone number'
                  className='mb-3'
                />
              </div>
            </div>
            <CurrencyInput
              label='Set a budget'
              value={item.budget}
              onChange={(v) => {
                handleChangeInput(index, 'budget', v);
              }}
              placeholder='50,000'
            />
          </div>
        ))}
      {active === 'manual' && <AddGuestManually />}
    </div>
  );
};

export default AddYourGuests;
